import React from 'react';
import styled, { css, keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const Divider = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 8px 0 16px;
  color: #64748b;
  font-size: 11px;
  white-space: nowrap;

  ${props => props.$fresh && css`
    animation: ${fadeIn} 0.35s ease-out;
  `}

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-top: 1px solid #cbd5e1;
  }
`;

// Marks where the chat changes hands, e.g. "Connected to Neela kanta · 5C Support" or
// "Transferred to Vijay S · 5C Support". The text comes from the Aura backend, already escaped.
const ChatDivider = ({ html, fresh }) => <Divider role="separator" $fresh={fresh} dangerouslySetInnerHTML={{ __html: html }} />;

export default ChatDivider;
